import { Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { dynamicNumber } from "../../../../Utils";
import { BorderWidthTitle } from "../../../../Constants/Constants";

const BorderWidth = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H6 className="mb-3">{BorderWidthTitle}</H6>
        {dynamicNumber(10).map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box border border-${item}`} />
            <span>{`.border-${item}`}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
export default BorderWidth;
